import React from "react";
import ProfileCard from "../../common/profileCard";
import StudentSidebar from "../../common/studentSidebar";
import SettingsLinks from "../settingsLinks/settingsLinks";
import ChangePasswordForm from "../../../common/ChangePasswordForm";

const StudentChangePassword = () => {
    return (
        <>
            <div className="content">
                <div className="container">
                    <ProfileCard />
                    <div className="row">
                        <StudentSidebar />
                        <div className="col-lg-9">
                            <div className="mb-3">
                                <h5>Settings</h5>
                            </div>
                            <SettingsLinks />
                            <ChangePasswordForm />
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default StudentChangePassword;
